import React from "react";
import "./virtualMoneies.styleton.scss";

function VirtualMoneiesSkeleton() {
    function randomNumber() {
        return Math.floor(Math.random() * 100 + 100);
    }
    return (
        <div className="tmex-virtual-moneies-skeleton">
            <div className="right-side">
                <div className="info">
                    <div className="icon"></div>
                    <div className="name">
                        <div className="top-name" />
                        <div
                            style={{ width: randomNumber() }}
                            className="bot-name"
                        />
                    </div>
                </div>
                <div className="button d-flex d-lg-none"></div>
            </div>
            <div className="left-side">
                <div className="chart"></div>
                <div className="price down">
                    <div
                        style={{ width: randomNumber() }}
                        className="top-price"
                    />
                    <div className="change" />
                </div>
            </div>
            <div className="button d-none d-lg-flex"></div>
        </div>
    );
}

export default VirtualMoneiesSkeleton;
